/* istanbul ignore file: unnecessary to test DOM methods */
import { SyntheticEvent } from "react";

export const handleFocus = (e: SyntheticEvent, id: string): void => {
  e.preventDefault();

  const target = document.getElementById(id);
  const button = target?.querySelector("button") as HTMLButtonElement;

  if (button.clientHeight) {
    button.focus();
  } else {
    target?.focus();
  }
};
